/*©**********************************************************************************
*                                                                                   *
* SPDX-License-Identifier: AGPL-3.0-or-later                                        *
*                                                                                   *
* This program is licensed under the GNU Affero General Public License v3+.         *
* See the LICENSE file or <https://www.gnu.org/licenses/agpl-3.0.html> for details. *
*                                                                                   *
**********************************************************************************©*/

declare global {
  interface Window {
    /** Set in index.tsx after fetching /public-config (backend APP_NAME). */
    __APP_NAME__?: string;
  }
}

function buildTimeAppName(): string {
  return (process.env.REACT_APP_APP_NAME || '').trim();
}

function apiBaseUrl(): string {
  return (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000').replace(/\/$/, '');
}

/**
 * Load display name from the API once per page load (runtime APP_NAME).
 * Falls back to REACT_APP_APP_NAME from build, then "ATP".
 */
export async function fetchRuntimeAppName(): Promise<string> {
  const fallback = buildTimeAppName() || 'ATP';
  try {
    const response = await fetch(`${apiBaseUrl()}/public-config`, {
      method: 'GET',
      credentials: 'omit',
    });
    if (!response.ok) {
      return fallback;
    }
    const data = (await response.json()) as { app_name?: string };
    const name = (data.app_name || '').trim();
    if (name) {
      window.__APP_NAME__ = name;
      return name;
    }
  } catch {
    // offline or CORS misconfiguration — use build-time / default
  }
  return fallback;
}

/** Sync read: use after fetchRuntimeAppName() has run (see index.tsx). */
export function getAppName(): string {
  const fromApi = typeof window !== 'undefined' ? (window.__APP_NAME__ || '').trim() : '';
  if (fromApi) {
    return fromApi;
  }
  return buildTimeAppName() || 'ATP';
}
